// biome-ignore lint/suspicious/noExplicitAny: biome migration
export const noOp = (_arg?: any) => {}

export const makeNoOp = () => () => {}
